import * as React from 'react';
import { useState, useEffect } from 'react';
import './LoadingPanel.scss';
import { WorkTracker } from './work-tracker';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

interface ILoadingPanelProps {
    workTracker: WorkTracker;
    style?: React.CSSProperties;
    children?: React.ReactNode;
}

const LoadingPanel: React.FC<ILoadingPanelProps> = ({ workTracker, style, children }) => {
    const [isLoadingComplete, setIsLoadingComplete] = useState<boolean>(workTracker.isComplete);
    const spinnerNodeRef = React.useRef<HTMLDivElement>(null);

    useEffect(() => {
        setIsLoadingComplete(workTracker.isComplete);
        const updateIsLoadingComplete = (isComplete: boolean) => {
            setIsLoadingComplete(isComplete);
        };
        workTracker.subscribe(updateIsLoadingComplete);
        return () => {
            workTracker.unsubscribe(updateIsLoadingComplete);
        };
    }, [workTracker]);

    const loaded = isLoadingComplete;
    return (
        <div className={`LoadingPanel ${loaded ? 'Loaded' : 'Loading'}`} style={style}>
            <TransitionGroup enter={true} exit={true} appear={true}>
                {loaded ? null : (
                    <CSSTransition nodeRef={spinnerNodeRef} classNames="Loading" timeout={400}>
                        <div ref={spinnerNodeRef}>
                            <Spinner className="Spinner" size={SpinnerSize.large} />
                            <div className="Overlay" />
                        </div>
                    </CSSTransition>
                )}
            </TransitionGroup>
            <div className="Content">{children}</div>
        </div>
    );
};

export default LoadingPanel;
